
import { ElementRef, DOCUMENT, inject } from '@angular/core';
import { AfterViewInit, ChangeDetectionStrategy, Component, Input, OnDestroy, Renderer2 } from '@angular/core';
import { ICustomWindow, WindowRefService } from '../_shared/services/window-ref.service';

const Z_INDEX = 10;

@Component({
    standalone: true,
    selector: 'sirius-dimmer',
    template: '',
    styleUrls: ['./dimmer.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class DimmerComponent implements AfterViewInit, OnDestroy {
    private _document = inject<Document>(DOCUMENT);
    private _elRef = inject(ElementRef);
    private _renderer = inject(Renderer2);
    private _windowRef = inject(WindowRefService);

    @Input() focusElement?: HTMLElement;

    private _orgIndex?: string;

    private get Window(): ICustomWindow | undefined {
        return this._windowRef.NativeWindow;
    }

    ngAfterViewInit(): void {
        if (!this.Window) {
            this._removeSelf();

            return;
        }

        if (!this.focusElement) {
            this._removeSelf(`Focus element is undefined. Cannot render dimmer.`);

            return;
        }

        this._orgIndex = this._document.defaultView?.getComputedStyle(this.focusElement).zIndex;

        if (!this._orgIndex) {
            this._removeSelf(`Focus element has no z-index value. Cannot render dimmer.`);

            return;
        }

        this._renderer.setStyle(this._elRef.nativeElement, 'z-index', Z_INDEX);
        this._renderer.setStyle(this.focusElement, 'z-index', `${Z_INDEX + 1}`);
    }

    ngOnDestroy(): void {
        if (!this._orgIndex) return;

        this._renderer.setStyle(this.focusElement, 'z-index', this._orgIndex);
    }

    private _removeSelf(errMessage?: string) {
        if (errMessage) console.error(errMessage);

        this._elRef.nativeElement.remove();
    }
}
